import SeccionLayout, { PieGuardar } from "../SeccionLayout";
import { AYUDA_SECCION } from "@/components/ayuda/vistas/configuracion";
import { useAppSettings, useBorradorSeccion } from "../useAppSettings";

/**
 * Qué buzones alimentan la Bandeja. Todo lo demás se ignora.
 */
export default function CorreoEntrante() {
  const { settings, cargando, guardando, guardar } = useAppSettings();
  const { valores, set, sucio } = useBorradorSeccion(settings, (s) => ({
    ingest_buzones_permitidos: s.ingest_buzones_permitidos,
  }));

  if (cargando || !valores) {
    return <p className="text-sm text-zinc-500">Cargando…</p>;
  }

  return (
    <SeccionLayout
      ayuda={AYUDA_SECCION["correo-entrante"]}
      ancho="formulario"
      titulo="Correo entrante"
      descripcion="Sólo entra a la Bandeja el correo dirigido a estos buzones, separados por coma. Lo demás —el spam de diccionario a info@, admin@ y compañía— se ignora y queda en la auditoría. Si lo dejas vacío entra todo."
    >
      <div className="card space-y-3">
        <label className="block text-xs text-zinc-400">
          Buzones que sí entran
          <input
            type="text"
            value={valores.ingest_buzones_permitidos}
            onChange={(e) => set({ ingest_buzones_permitidos: e.target.value })}
            placeholder="casos@arknex.net"
            className="input mt-1 w-full font-mono text-sm"
          />
        </label>
        <PieGuardar
          sucio={sucio}
          guardando={guardando}
          onGuardar={() => void guardar(valores, "Buzones guardados")}
          textoGuardar="Guardar los buzones"
        />
      </div>
    </SeccionLayout>
  );
}
